import { connect } from 'react-redux';
import isNil from 'lodash/isNil';
import View from './DisabilityView';
import MobileView from '../../../MobileFinancialPlan/MobileInsurance/MobileDisability/MobileDisabilityView';
import { getSubgoal, getNote } from './DisabilityHelpers';
import { updateGoalViewState } from '../../FinancialPlanActions';
import { selectedOwnerName, selectedIndex } from '../OwnerDropdown/OwnerDropdownSelector';
import { insuranceNotes } from '../NotesPopup/NotesPopupSelector';

const mapStateToProps = (state, ownProps) => {
  const selectedGoal = getSubgoal(ownProps.insuranceGoal);
  const ownerDropdownProps = {
    clientId: ownProps.clientId,
    goalId: ownProps.goalId,
    subgoalId: ownProps.selectedSection,
    spouseName: selectedGoal.DisabilityInsurance.SpouseName,
    principalName: selectedGoal.DisabilityInsurance.PrincipalName,
    selectedGoal,
  };
  return {
    selectedGoal,
    note: getNote(insuranceNotes(state, ownerDropdownProps)),
    subgoalData: selectedGoal.DisabilityInsurance,
    subgoalId: ownProps.selectedSection,
    selectedOwnerName: !isNil(ownProps.selectedOwnerName)
      ? ownProps.selectedOwnerName
      : selectedOwnerName(state, ownerDropdownProps),
    selectedOwnerIndex: !isNil(ownProps.selectedOwnerIndex)
      ? ownProps.selectedOwnerIndex
      : selectedIndex(state, ownerDropdownProps),
  };
};

const mapDispatchToProps = dispatch => ({
  setSelectedOwnerIndex: (clientId, goalId) => ownerIndex => event => {
    dispatch(
      updateGoalViewState(goalId, clientId, {
        ownerIndex,
      }),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
export const MobileDisability = connect(mapStateToProps, mapDispatchToProps)(MobileView);
